import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action, fill_master_action } from '../../../../../actions/fillCombo_action';
import { cityActionId, countryActionId, toastError, stalltypeMasterListActionId, dashboardDownloadListId, countryMasterListActionId, toastSuccess } from "../../../../../utils/constants";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-modal";
import moment from "moment";
import Exh_chapter from '../exh_chapter/exh_chapter';
import Resizer from "react-image-file-resizer";
// import ManageArea from './manage_area/manage_area';
import Exh_timeline from '../exh_timeline/exh_timeline';
import ManageAreaMaster from '../manage_area_master/manage_area_master';
import ManualFormsMaster from "../manual_froms_master/manual_forms_master";
import AdminDrawer from "../../../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../../../common_components/header_with_logo";
import { useNavigate } from "react-router-dom";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import {
    updateDelegateConfiguration_action, getDelegateConfigurationDetails_action
} from "../../../../../actions/admin_module_action/master_action/exhibition_master_action/delegateConfiguration_action";

class DelegateConfigration extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            IsPaidDelegateRegistration: false,
            DelegateRegFeeInUSD: '',
            IsGSTIncluded: false,
            ExihibitionID: '',
            VisaApprovalLastDate: null
        }

    }

    componentDidMount() {
        this.setState({
            ExihibitionID: this.props.location.state.ExihibitionID != undefined ? (this.props.location.state != null && this.props.location.state.ExihibitionID != null ? this.props.location.state.ExihibitionID : '') : this.props.id != null && this.props.id != undefined ? this.props.id : '',
        }, () => {
            this.getDelegateConfigrationDetails()
        })

    }

    getDelegateConfigrationDetails() {
        const { ExihibitionID, allocateStalltypeList, exhibitionRandR, allocateCountryList } = this.state
        this.setState({ isLoading: true })
        this.props.getDelegateConfigurationDetails_action(ExihibitionID)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({
                        IsPaidDelegateRegistration: data.data[0].IsPaidDelegateRegistration,
                        DelegateRegFeeInUSD: data.data[0].DelegateRegFeeInUSD,
                        IsGSTIncluded: data.data[0].IsGSTIncluded,
                        VisaApprovalLastDate: data.data[0].VisaApprovalLastDate ? moment(data.data[0].VisaApprovalLastDate, 'YYYY-MM-DD').toDate() : null,
                    })
                    this.setState({ isLoading: false })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    updateDelegateConfigration() {
        const { ExihibitionID, IsPaidDelegateRegistration, DelegateRegFeeInUSD, IsGSTIncluded, VisaApprovalLastDate } = this.state
        const formateDate = VisaApprovalLastDate ? moment(VisaApprovalLastDate).format('YYYY-MM-DD') : null;
        this.setState({ isLoading: true })
        this.props.updateDelegateConfiguration_action(ExihibitionID, IsPaidDelegateRegistration, DelegateRegFeeInUSD, IsGSTIncluded, formateDate)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ isLoading: false, })
                    toastSuccess("data updated successfully")
                    this.getDelegateConfigrationDetails()

                    // window.location.reload()
                    // this.props.navigate('/exhibitionMasterAU',)
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }


    render() {
        const { isLoading, IsPaidDelegateRegistration, DelegateRegFeeInUSD, IsGSTIncluded, VisaApprovalLastDate } = this.state

        return (
            <>

                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}

                <ToastContainer />
                <HeaderWithLogo />
                <>
                    <AdminDrawer />


                    <div className="main-container admin-top-space mx-2 p-3">
                        <div class="row">
                            <div className="col-xl-4 mt-2">
                                <label> Delegate Registration Fees (USD)</label>
                                <input type="text" name=""
                                    className="form-control"
                                    placeholder="0.00"
                                    value={DelegateRegFeeInUSD}
                                    onChange={(e) => {
                                        let value = e.target.value;

                                        // Remove everything except numbers and dot
                                        value = value.replace(/[^0-9.]/g, '');

                                        // Prevent multiple decimal points
                                        const parts = value.split('.');
                                        if (parts.length > 2) {
                                            value = parts[0] + '.' + parts[1];
                                        }

                                        this.setState({
                                            DelegateRegFeeInUSD: value
                                        });
                                    }}
                                />
                            </div>
                            <div className="col-xl-4 mt-2">
                                <label> Visa Approval Last Date</label>
                                <DatePicker
                                    selected={VisaApprovalLastDate}
                                    dateFormat={"dd/MM/yyyy"}
                                    className="form-control"
                                    onChange={(date) => this.setState({ VisaApprovalLastDate: date })}
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    placeholderText="DD/MM/YYYY"
                                />
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div className="col-xl-4 mt-2">
                                <input type="checkbox" name="" key={IsPaidDelegateRegistration}
                                    checked={IsPaidDelegateRegistration}
                                    onClick={(e) => this.setState({ IsPaidDelegateRegistration: !IsPaidDelegateRegistration })}
                                />
                                Is Delegate Registration Paid
                            </div>
                        </div>
                        <div class="row">
                            <div className="col-xl-4 mt-2">
                                <input type="checkbox" name="" key={IsGSTIncluded}
                                    checked={IsGSTIncluded}
                                    onClick={(e) => this.setState({ IsGSTIncluded: !IsGSTIncluded })}
                                />
                                Is GST Included
                            </div>
                        </div>
                        <div class="row mt-3">

                            <div class="col-md-12">

                                <div style={{ float: 'right', textAlign: 'right' }}>
                                    <button onClick={() => this.updateDelegateConfigration()} class="btn rounded-1 btn-aqua mt-3">Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            </>)
    }
}

export default withRouter(connect(null, {
    updateDelegateConfiguration_action, getDelegateConfigurationDetails_action
})(DelegateConfigration));